import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from "@mui/material";
import axios from "axios";
import {
  CurrencyNumberInput,
  DateTimePicker,
  FormLabel,
  ModalError,
  ModalSuccess,
  PrimaryButton,
  SecondaryButton,
  TextInput,
} from "components";
import moment from "moment-timezone";
import { useState } from "react";
import { hardBaseUrl, hardTypeWeb } from "services/urlConstant";
import { formatPayloadTimezone, getCookie, getErrors } from "utils";

const ModalFormExchangeRate = ({ open, onClose, preload, getDataTable }) => {
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  const userLogin = getCookie("auth", `${process.env.REACT_APP_NAME}_user`);
  const isMpis = hardTypeWeb === "mpis";

  const [loadingButton, setLoadingButton] = useState(false);
  const [payload, setPayload] = useState({
    currency_id: Number(preload?.currency_id),
    start_date: moment(),
    end_date: moment().add(1, "day"),
    value: 0,
    ...(!isMpis && {
      publisher_id: userLogin?.publisher?.publisher_id,
    }),
  });

  const handleChangePayload = (value, key) => {
    setPayload(currentState => ({
      ...currentState,
      [key]: value,
    }));
  };
  const handleStartDateChange = newStartDate => {
    let newEndDate = payload.end_date;
    if (
      !newEndDate ||
      moment(newEndDate).isBefore(moment(newStartDate).add(1, "day"))
    ) {
      newEndDate = moment(newStartDate).add(1, "day");
    }

    setPayload(prevPayload => ({
      ...prevPayload,
      start_date: newStartDate,
      end_date: newEndDate,
    }));
  };
  const handleEndDateChange = newEndDate => {
    const start = moment(payload.start_date);
    let end = moment(newEndDate);
    if (end.isSameOrBefore(start.add(1, "day"))) {
      end = moment(payload.start_date).add(1, "day");
    }

    setPayload(prevPayload => ({
      ...prevPayload,
      end_date: end,
    }));
  };
  const validatePayload = () => {
    const errors = [];
    const errorEmpty = error => `${error} can't be empty.`;

    if (!payload.value) {
      errors.push(errorEmpty("Value"));
    } else if (!payload?.start_date) {
      errors.push(errorEmpty("Start Date"));
    } else if (!payload?.end_date) {
      errors.push(errorEmpty("End Date"));
    }
    return errors;
  };

  const handleSubmit = async () => {
    const errors = validatePayload();
    if (errors?.length) {
      ModalError(errors[0]);
      return;
    }
    const modifiedPayload = {
      ...payload,
      start_date: formatPayloadTimezone(payload.start_date),
      end_date: formatPayloadTimezone(payload.end_date),
    };
    try {
      setLoadingButton(true);
      await axios.post(`${hardBaseUrl}/exchange-rate/create`, modifiedPayload, {
        headers,
      });
      ModalSuccess("Successfully Add Exchange Rate").then(() => getDataTable());
    } catch (error) {
      ModalError(getErrors(error?.response));
    } finally {
      setLoadingButton(false);
      onClose();
    }
  };

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle>Create Exchanges rate</DialogTitle>
      <DialogContent dividers>
        <Grid container direction="column" rowSpacing={2}>
          {MockFieldForm?.map(({ title, key, type }, index) => (
            <Grid item key={index}>
              <FormLabel label={title} required />
              {type === "date" ? (
                <DateTimePicker
                  value={payload?.[key]}
                  onChange={
                    key === "end_date"
                      ? handleEndDateChange
                      : handleStartDateChange
                  }
                  minDate={
                    key === "end_date"
                      ? moment(payload.start_date).add(1, "day")
                      : moment().subtract(8, "years")
                  }
                  maxDate={moment().add(10, "years")}
                />
              ) : type === "currency" ? (
                <CurrencyNumberInput
                  value={payload?.[key]}
                  onChange={value => handleChangePayload(value, key)}
                  decimalScale={2}
                  disabled={loadingButton}
                />
              ) : (
                <TextInput
                  value={preload?.[key]}
                  onChange={e => handleChangePayload(e?.target?.value, key)}
                  disabled
                />
              )}
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions>
        <SecondaryButton label="Cancel" onClick={onClose} />
        <PrimaryButton
          label={loadingButton ? "Saving" : "Save"}
          loading={loadingButton}
          disabled={loadingButton}
          onClick={handleSubmit}
        />
      </DialogActions>
    </Dialog>
  );
};

const MockFieldForm = [
  {
    title: "Start Date",
    key: "start_date",
    type: "date",
  },
  {
    title: "End Date",
    key: "end_date",
    type: "date",
  },
  {
    title: "Currency",
    key: "currency",
  },
  {
    title: "Value",
    key: "value",
    type: "currency",
  },
];
export default ModalFormExchangeRate;
